import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {User} from './user-account.model';
import {AppConfigService} from '../common/service/app-config.service';

@Injectable({
    providedIn: 'root'
})
export class NlrUserAccountDetailsService {
    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {}

    getUser(userName: string): Observable<User> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/ldapuserinfo/getuserdata';
        return this.http.post<User>(url, userName);
    }
}
